module.exports = __webpack_public_path__ + "img/logoESGKepzes.5df62c3e.png";